/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantOrgCapabilitiesVmcfs } from './tenantOrgCapabilitiesVmcfs';


export interface VmcfsTenantProperties { 
    org_id: string;
    org_name?: string;
    org_type?: string;
    erp_id?: string;
    capabilities?: TenantOrgCapabilitiesVmcfs;
}

